var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:edit-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.63614 14.6358L3.72705 18.2722L7.36341 17.3631L17.8961 6.83038C18.237 6.48942 18.4285 6.02704 18.4285 5.54493C18.4285 5.06281 18.237 4.60043 17.8961 4.25947L17.7398 4.10311C17.3988 3.76225 16.9364 3.57077 16.4543 3.57077C15.9722 3.57077 15.5098 3.76225 15.1689 4.10311L4.63614 14.6358Z",
    stroke: "black",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.63614 14.6361L3.72705 18.2725L7.36341 17.3634L16.4543 8.27247L13.7271 5.5452L4.63614 14.6361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.7271 5.5452L16.4544 8.27247M11.9089 18.2725H19.1817",
    stroke: "black",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.22faf2860d143ee56fa87be7a411ca53.svg";
export { ForwardRef as ReactComponent };